/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartnerModalComponent} from './partner-modal.component';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {InputModule} from '../../../../shared/input/input.module';
import {ActiveInputModule} from '../active-input/active-input.module';
import {PipesModule} from '../../../../shared/pipes/pipes.module';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';

@NgModule({
    declarations: [PartnerModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        InputModule,
        ActiveInputModule,
        PipesModule,
        TooltipModule
    ]
})
export class PartnerModalModule {
}
